import React, { useState } from 'react';
import {
  Box,
  Button,
  Modal,
  Typography,
  TextField,
  Autocomplete
} from '@mui/material';
import servicio1 from '../../../services/servicio1';

export default function ConvocarJugadores({ id_partido }) {
  const [open, setOpen] = useState(false);
  const [jugadores, setJugadores] = useState([]);
  const [jugadorSeleccionado, setJugadorSeleccionado] = useState(null);

  const buscarJugadores = async (texto) => {
    try {
      const res = await servicio1.traerJugadores(texto);
      setJugadores(res);
    } catch (e) {
      console.error('Error buscando jugadores', e);
    }
  };

  const convocarJugador = async () => {
    if (!jugadorSeleccionado) return alert('Seleccioná un jugador');
    try {
      await servicio1.enviarConvocatoria({ id_partido, id_usuario: jugadorSeleccionado.id });
      alert('Convocatoria enviada');
      setOpen(false);
      setJugadorSeleccionado(null);
    } catch (e) {
      console.error('Error al convocar', e);
      alert('Error al enviar la convocatoria');
    }
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} variant="outlined" sx={{ mt: 1 }}>
        Convocar
      </Button>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={{
          backgroundColor: 'white',
          p: 3,
          m: 2,
          borderRadius: 2,
          maxHeight: '90vh',
          overflowY: 'auto'
        }}>
          <Typography variant="h6" gutterBottom>
            Buscar jugadores
          </Typography>

          <Autocomplete
            freeSolo
            options={jugadores}
            getOptionLabel={(option) =>
              option?.nombre
                ? `${option.nombre}${option.apodo ? ` (${option.apodo})` : ''}`
                : ''
            }
            onInputChange={(event, newInputValue) => {
              buscarJugadores(newInputValue);
            }}
            onChange={(event, newValue) => {
              setJugadorSeleccionado(newValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Nombre o barrio" variant="outlined" size="small" />
            )}
            sx={{ mb: 2 }}
          />

          <Button
            variant="contained"
            fullWidth
            onClick={convocarJugador}
            disabled={!jugadorSeleccionado}
          >
            Enviar convocatoria
          </Button>
        </Box>
      </Modal>
    </>
  );
}
